/**
 * Classes Tailwind v3 partagées pour le chantier responsive.
 * Alignées AdminCN (`max-w-[calc(100%-2rem)]`) — à composer via `cn()`,
 * **avant** `className` pour qu'un `max-w-*` métier puisse overlay.
 */

/**
 * Dialog formulaire : marges viewport + scroll vertical.
 * La largeur est un `w-[calc(100%-2rem)]` (pas seulement un `max-w`) pour
 * que un `max-w-2xl` métier, fusionné par tailwind-merge, ne supprime pas
 * la marge mobile. `sm:max-w-3xl` ne s'applique qu'à partir de `sm` ;
 * pour aller plus large : `sm:max-w-4xl`. `[&_form]:gap-6` aère les
 * grilles `gap-4` sans forcer le nombre de colonnes.
 */
export const dialogContentResponsiveClass =
  "show-scrollbar w-[calc(100%-2rem)] max-w-[calc(100vw-2rem)] max-h-[min(90dvh,90vh)] min-w-0 overflow-x-hidden overflow-y-auto overscroll-contain p-4 sm:max-w-3xl sm:p-8 [&_form]:min-w-0 [&_form]:gap-6";

/** Preview / dialogs lourds : plein écran sous `sm`. */
export const dialogFullscreenMobileClass =
  "max-sm:!inset-0 max-sm:!left-0 max-sm:!top-0 max-sm:!right-0 max-sm:!h-dvh max-sm:!max-h-dvh max-sm:!w-full max-sm:!max-w-none max-sm:!translate-x-0 max-sm:!translate-y-0 max-sm:!transform-none max-sm:!rounded-none max-sm:!overflow-hidden max-sm:!gap-0 max-sm:!p-0";

/**
 * Largeur / padding d'une preview lourde.
 * Conserve le cap AdminCN `calc(100%-2rem)` à tous les breakpoints :
 * `sm:max-w-4xl` seul déborde entre 640 et 896 px (centrage 50% + w-full).
 */
export const dialogPreviewContentClass =
  "min-w-0 gap-0 overflow-hidden border-none bg-transparent p-0 sm:p-0 w-full max-w-[calc(100%-2rem)] sm:max-w-[min(56rem,calc(100%-2rem))] lg:max-w-[min(64rem,calc(100%-2rem))] xl:max-w-[min(72rem,calc(100%-2rem))]";
